import {
  SET_SHOW_LOGO,
  SET_SHOW_ARTWORK_DETAILS,
  SET_SWITCH_ARTWORK,
  SET_4K_QUALITY,
  SET_MUTE,
  QR,
  MATCHCONTENT,
  FILL_SCREEN,
  RANDOMISE
} from '../constants/settingContants';

export const setShowLogo = (payload) => ({ type: SET_SHOW_LOGO, payload });
export const setShowArtworkDetails = (payload) => ({ type: SET_SHOW_ARTWORK_DETAILS, payload });
export const setSwitchArtwork = (payload) => ({ type: SET_SWITCH_ARTWORK, payload });
export const set4kQuality = (payload) => ({ type: SET_4K_QUALITY, payload });
export const setMute = (payload) => ({ type: SET_MUTE, payload });
export const setQR = (payload) => ({ type: QR, payload });
export const setMatchContent = (payload) => ({ type: MATCHCONTENT, payload });
export const setFillScreen = (payload) => ({ type: FILL_SCREEN, payload });
export const setRandomise = (payload) => ({ type: RANDOMISE, payload });
